import {
	byCreatedDesc,
	type BuilderCtx,
	CAP,
	type Collection,
} from './shared.ts'

// Newest additions first. No filter equivalent, so no "See all".
export const buildRecentRow = ({ activities }: BuilderCtx): Collection => ({
	key: 'recent',
	title: 'Recently added',
	activities: [...activities].sort(byCreatedDesc).slice(0, CAP),
})
